import { render, staticRenderFns } from "./PropertiesForSale.vue?vue&type=template&id=4623ce85&scoped=true&"
import script from "./PropertiesForSale.vue?vue&type=script&lang=ts&"
export * from "./PropertiesForSale.vue?vue&type=script&lang=ts&"
import style0 from "./PropertiesForSale.vue?vue&type=style&index=0&id=4623ce85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4623ce85",
  null
  
)

export default component.exports